import { render, staticRenderFns } from "./_Alert.vue?vue&type=template&id=9713ca72&scoped=true&"
import script from "./_Alert.vue?vue&type=script&lang=js&"
export * from "./_Alert.vue?vue&type=script&lang=js&"
import style0 from "./_Alert.vue?vue&type=style&index=0&id=9713ca72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9713ca72",
  null
  
)

export default component.exports